export function userIndex(index) {
    const z = '0';
    var n = index + '';
    return n.length >= 4 ? '#' + n : '#' + new Array(4 - n.length + 1).join(z) + n;
}